/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * Convenience enum for custom icons.
 */
export enum CustomIconName {
  AREA_CREATE = "fak fa-area-create",
  AREA_SLASH = "fak fa-area-slash",
  ASSIGNMENT_REJECT = "fak fa-assignment-reject",
  ATTACHMENT_ADD = "fak fa-attachment-add",
  ATTACHMENT_SLASH = "fak fa-attachment-slash",
  AUDIT_ACCEPTED = "fak fa-audit-accepted",
  AUDIT_REJECTED = "fak fa-audit-rejected",
  FEEDBACK = "fak fa-feedback",
  HAS_IDENTIFIER = "fak fa-has-identifier",
  IDENTIFY = "fak fa-identify",
  IMAGE_ERROR = "fak fa-image-error",
  ISSUE_CREATE = "fak fa-issue-create",
  ISSUE_SLASH = "fak fa-issue-slash",
  ISSUES = "fak fa-issues",
  ITEM_CLONE = "fak fa-item-clone",
  ITEM_CREATE = "fak fa-item-create",
  ITEM_SLASH = "fak fa-item-slash",
  ITEMS = "fak fa-items",
  LAYOUT_CREATE = "fak fa-layout-create",
  LAYOUT_SLASH = "fak fa-layout-slash",
  LOCATION_CREATE = "fak fa-location-create",
  LOCATIONS = "fak fa-locations",
  MODEL_CLONE = "fak fa-model-clone",
  MODEL_CREATE = "fak fa-model-create",
  MODEL_SLASH = "fak fa-model-slash",
  MODELS = "fak fa-models",
  PERFORMED_WORK_LIST = "fak fa-performed-work-list",
  PERFORMED_WORK_LIST_SLASH = "fak fa-performed-work-list-slash",
  S_FILE_EXPORT = "fak fa-s-file-export",
  TIMED_UNDO = "fak fa-timed-undo",
  WORK_CORRECTIVE = "fak fa-work-corrective",
  WORK_CORRECTIVE_SLASH = "fak fa-work-corrective-slash",
  WORK_REGULAR = "fak fa-work-regular",
  WORK_REGULAR_SLASH = "fak fa-work-regular-slash",
  WORKDOMAIN = "fak fa-workdomain",
  WORKDOMAINS = "fak fa-workdomains",
  WORKORDER_ADD_TO = "fak fa-workorder-add-to",
  WORKORDER_CLONE = "fak fa-workorder-clone",
  WORKORDER_CREATE = "fak fa-workorder-create",
  WORKORDER_REMOVE_FROM = "fak fa-workorder-remove-from",
  WORKORDER_SLASH = "fak fa-workorder-slash",
  WORKSPACES = "fak fa-workspaces",
  ZONES = "fak fa-zones",
  ZONES_SLASH = "fak fa-zones-slash",
}
